import React from 'react'

const Last = () => {
return (
    <div className='bg-[#FBB14B]'>
        <div className='flex items-center justify-between px-2 py-4 md:px-5 md:py-7 5xl:px-10  7xl:px-14 10xl:px-24 10xl:py-9 11xl:py-12 '>
            <p className='text-xs  xs:w-[200px] sm:w-[230px] md:w-[260px] lg:w-[280px] xl:w-[290px] 2xl:w-[320px] 3xl:w-auto md:text-lg 4xl:text-xl 5xl:text-2xl 9xl:text-3xl 10xl:text-4xl 11xl:text-5xl font-bold'>
                Our saree collection are on our YouTube channel
            </p>
            <a
                className="font-semibold border-2 rounded-full text-xs md:text-lg 5xl:text-xl 9xl:text-2xl 10xl:text-3xl 11xl:text-4xl 5xl:p-3 9xl:p-5 p-1 text-[#ffff] border-[#850B62] bg-[#850B62] items-center text-white flex justify-center ml-2 md:ml-4 px-2 py-1"
                href="https://www.youtube.com/@P.R.Silksthirubuvanam"
            >
                Watch Now
            </a>
        </div>
    </div>
)
}

export default Last